
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


const BASE_URL_O = "https://gateway.turkmakbuz.com.tr/api/"; // test sunucu
//const BASE_URL_O = "https://edonusumservis.ardsistem.com.tr/api/"; // test sunucu
// const BASE_URL_O = "https://turkmakbuzapi.turkfatura.com.tr/api/"; // canlı ortam sunucu
// const BASE_URL_O = "https://makbuztekapi.makbuztek.com.tr/api/"; // canlı ortam sunucu
// const BASE_URL_O = "https://edonusumservisa1.turkfatura.com.tr/api/"; // canlı ortam sunucu
//const BASE_URL_O = "http://makbuztekapitest.makbuztek.com.tr/api/"; // test ortam sunucu
// const BASE_URL_O = "http://turkmakbuzapitest.turkmakbuz.com.tr/api/"; // test ortam sunucu

const KEP_STATUS = false;
// const SIGNALR_API_URL = "http://notification.ardsistem.com.tr/"
// const SIGNALR_API_URL = "https://localhost:62879/"
const SIGNALR_API_URL = "https://test2.turkfatura.com.tr/"

var loginType: number;

loginType = Number("3");

var applicationType: number;

applicationType = Number("");

export const environment = {
    production: true,
    LOGIN_TIPI: loginType,
    APPLICATION_TIPI: applicationType,
    VERSION: "1.0.9",
    API_GENEL_URL: BASE_URL_O + "ardedonusumgenel/",
    API_KULLANICI_URL: BASE_URL_O + "kullanici/",
    API_IL_ILCE_URL: BASE_URL_O + "ililce/",
    API_MENU_URL: BASE_URL_O + "solmenuislemleri/",
    API_VERGI_TURLERI_URL: BASE_URL_O + "vergituru/",
    API_VERGI_DAIRELERI_URL: BASE_URL_O + "vergidaireleri/",
    API_BIRIMLER_URL: BASE_URL_O + "birimler/",
    API_FATURALAR_URL: BASE_URL_O + "faturalar/",
    API_KEP_URL: BASE_URL_O + "kep/",
    API_FATURA_RAPOR_YAZDIR_URL: BASE_URL_O + "faturaraporuyazdir/",
    API_FATURA_RAPOR_YAZDIR_TEK_PDF_URL: BASE_URL_O + "tekpdfac/",
    API_XSLT_URL: BASE_URL_O + "xslt/",
    API_RAPORLAR_URL: BASE_URL_O + "raporlar/",
    API_EDEFTER_URL: BASE_URL_O + "edefter/",
    API_FATURA_GORUNTULE: BASE_URL_O + "faturagoruntule/",
    API_CARI_URL: BASE_URL_O + "cari/",
    API_CARIGRUP_URL: BASE_URL_O + "carigrup/",
    API_CARIADRES_URL: BASE_URL_O + "cariadres/",
    API_FATURA_NUMARA_SAYAC_URL: BASE_URL_O + "faturanumarasayac/",
    API_EFATURA_MUKELLEF_URL: BASE_URL_O + "efaturamukellef/",
    API_NACE_KODLARI_URL: BASE_URL_O + "nacekodlari/",
    API_ON_TANIMLAR_URL: BASE_URL_O + "ontanimlar/",
    API_UNVAN_TIPLERI_URL: BASE_URL_O + "unvantipleri/",
    API_MESLEK_TIPLERI_URL: BASE_URL_O + "meslektipleri/",
    API_BUROLAR_URL: BASE_URL_O + "burolar/",
    API_BURO_SUBE_URL: BASE_URL_O + "burosube/",
    API_BURO_KULLANICI_URL: BASE_URL_O + "burokullanici/",
    API_BURO_BANKA_URL: BASE_URL_O + "burobanka/",
    API_BURO_MUHASEBECI_MALI_MUSAVIR_URL: BASE_URL_O + "buromuhasebecimalimusavir/",
    API_BAYI_URL: BASE_URL_O + "bayi/",
    API_TALEP_URL: BASE_URL_O + "talep/",
    API_TALEP_TIPI_URL: BASE_URL_O + "taleptipi/",
    API_TALEP_KATEGORISI_URL: BASE_URL_O + "talepkategorisi/",
    API_YARDIM_VIDEOLARI_URL: BASE_URL_O + "yardimvideolari/",
    API_DUYURULAR_URL: BASE_URL_O + "duyurular/",
    API_ETIKETLER_URL: BASE_URL_O + "etiketler/",
    API_KONTOR_SIPARIS_URL: BASE_URL_O + "kontorsiparis/",
    API_BURO_LISANSLAMA_URL: BASE_URL_O + "burolisanslama/",
    API_ANALIZ_URL: BASE_URL_O + "analiz/",
    API_IRSALIYE_NUMARA_SAYAC_URL: BASE_URL_O + "irsaliyenumarasayac",
    API_IRSALIYELER_URL: BASE_URL_O + "irsaliyeler/",
    API_IRSALIYE_GORUNTULE: BASE_URL_O + "irsaliyegoruntule/",
    API_IRSALIYE_YAZDIR_URL: BASE_URL_O + "irsaliyeyazdir/",
    API_GIB_SISTEM_YANITI_URL: BASE_URL_O + "gibsistemyaniti/",
    API_SSS_URL: BASE_URL_O + "sss/",
    API_ETS_URL: BASE_URL_O + "etstahsilat/",
    API_KARAYOLUEBILET_URL: BASE_URL_O + "karayoluebilet/",
    API_HAVAYOLUEBILET_URL: BASE_URL_O + "havayoluebilet/",
    API_ETKINLIKEBILET_URL: BASE_URL_O + "etkinlikebilet/",
    API_YOLCULISTESI_URL: BASE_URL_O + "yolculistesi/",
    VERI_AKTARIM_URL: BASE_URL_O + "VeriAlGonder/",
    BASE_URL: BASE_URL_O,
    KEP_STATUS: KEP_STATUS,
    BASVURU_URL: BASE_URL_O + "Basvuru/",
    API_HELPDESK_URL: BASE_URL_O + "HelpDesk/",
    INDIRME_ISTEKLERI_URL: BASE_URL_O + "IndirmeIstekleri/",
    API_MOBIL: BASE_URL_O + "Mobil/",
    API_NOTF_HUB_URL: SIGNALR_API_URL + "notificationHub",
    API_MUKELLEF_KAMU: BASE_URL_O + "MukellefKamu/"

};
